import React, { useEffect, useState } from 'react';
import Input from '../../../shared/components/Input/Input';
import Dialog from '../../../shared/components/Dialog/Dialog';
import { hasRHValidationErrors, validateRHPassword } from '../utils/rhValidation';

const emptyForm = { currentPassword: '', newPassword: '', confirmPassword: '' };

function RHPasswordDialog({ open, loading = false, error = '', onClose, onSubmit }) {
  const [form, setForm] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  useEffect(() => { if (open) { setForm(emptyForm); setErrors({}); } }, [open]);
  const change = ({ target: { name, value } }) => { setForm((current) => ({ ...current, [name]: value })); setErrors((current) => ({ ...current, [name]: undefined })); };
  const submit = () => { const nextErrors = validateRHPassword(form); setErrors(nextErrors); if (!hasRHValidationErrors(nextErrors)) onSubmit?.({ currentPassword: form.currentPassword, newPassword: form.newPassword }); };
  return (
    <Dialog open={open} onClose={onClose} onSubmit={submit} title="Changer mon mot de passe" submitLabel="Mettre à jour" loading={loading}>
      {error && <p className="rh-form-error" role="alert">{error}</p>}
      <Input fullWidth type="password" autoComplete="current-password" label="Mot de passe actuel" name="currentPassword" value={form.currentPassword} onChange={change} error={errors.currentPassword} />
      <Input fullWidth type="password" autoComplete="new-password" label="Nouveau mot de passe" name="newPassword" value={form.newPassword} onChange={change} error={errors.newPassword} />
      <Input fullWidth type="password" autoComplete="new-password" label="Confirmer le mot de passe" name="confirmPassword" value={form.confirmPassword} onChange={change} error={errors.confirmPassword} />
    </Dialog>
  );
}

export default RHPasswordDialog;
